/** @jsx jsx */
import { ArrowBackIcon, Box, Button, ChevronDownIcon, Container, Flex } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { DialogDisclosure, DialogStateReturn } from "reakit/Dialog";
import { MenuButton } from "reakit/Menu";
import { jsx } from "theme-ui";

import { DropdownMenu, DropdownMenuItem, useDropdownMenuState } from "@/components/dropdowns";
import { isTimeReportEditable, TimeReport } from "@/data/time-reports";
import { usePreviousRoutePath } from "@/infrastructure/Route";
import { router } from "@/views/router";
import { TimeReportHeader } from "@/views/time-reports/header";

import { TimeReportDetailsTabs } from "./TimeReportDetailsTabs";

interface TimeReportDetailsHeaderProps {
  timeReport: TimeReport;
  editModalState: DialogStateReturn;
  previewModalState: DialogStateReturn;
}

export const TimeReportDetailsHeader: FC<TimeReportDetailsHeaderProps> = ({
  timeReport,
  editModalState,
  previewModalState,
}) => {
  const { t } = useTranslation("session");

  const { previousPath } = usePreviousRoutePath();

  const actionsState = useDropdownMenuState();

  return (
    <Box bg="n0" borderColor="n100" borderBottom="primary" pt="sm">
      <Container>
        <Flex px="sm" flexDirection="column" gap="sm">
          <div>
            <Button
              as={Link}
              to={previousPath ?? router.get("time-reports").path}
              variant="ghost"
              size="sm"
              iconLeft={<ArrowBackIcon />}>
              {t("TIME_REPORTS.DETAILS.BACK_TO_TIME_REPORTS")}
            </Button>
          </div>

          <Flex flexDirection={["column", null, null, "row"]} justifyContent="space-between" gap="sm">
            <TimeReportHeader timeReport={timeReport} />

            {isTimeReportEditable(timeReport) && (
              <div>
                <Button as={MenuButton} variant="secondary" iconRight={<ChevronDownIcon />} {...actionsState}>
                  {t("TIME_REPORTS.DETAILS.ACTIONS")}
                </Button>

                <DropdownMenu {...actionsState}>
                  <DropdownMenuItem {...actionsState} as={DialogDisclosure} {...editModalState}>
                    {t("TIME_REPORTS.DETAILS.ACTION_EDIT")}
                  </DropdownMenuItem>
                  <DropdownMenuItem {...actionsState} as={DialogDisclosure} {...previewModalState}>
                    {t("TIME_REPORTS.DETAILS.ACTION_SUBMIT")}
                  </DropdownMenuItem>
                </DropdownMenu>
              </div>
            )}
          </Flex>

          <TimeReportDetailsTabs timeReport={timeReport} />
        </Flex>
      </Container>
    </Box>
  );
};
